export const fetchHelper = async ({ url, body }) => {
  return fetch(url, {
    method: "POST",
    body: JSON.stringify(body)
  })
    .then(response => response.json())
    .catch(err => ({ success: false, message: err.message }));
};
